import {
  Box,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from '@mui/material';

import { TableNoData } from 'src/components/table';

import UnitStatExposuresRow from './unit-stat-exposures-table-row';

import type { USRExposuresTableRow } from '../types';

export default function UnitStatExposuresTable({
  dataTestId,
  title,
  rows,
  columns,
  exposuresAreHidden,
}: {
  dataTestId: string;
  title: string;
  rows: USRExposuresTableRow[];
  columns: string[];
  exposuresAreHidden: boolean;
}) {
  return (
    <Box>
      <Typography
        variant="subtitle1"
        color="text.primary"
        data-testid="unit-stat-exposures-title"
        sx={{ mb: 2 }}
      >
        {title}
      </Typography>
      <TableContainer>
        <Table data-testid={dataTestId}>
          <TableHead>
            <TableRow>
              <TableCell />
              {columns.map((col) => (
                <TableCell key={col} sx={{ width: `${100 / columns.length}%` }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, idx) => <UnitStatExposuresRow key={idx} row={row} rowIndex={idx} />)
            ) : (
              <TableNoData
                notFound
                description={
                  exposuresAreHidden
                    ? 'Exposures are only reported on the first unit statistical report.'
                    : ''
                }
              />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
